export default __webpack_public_path__ + "static/media/boHeadshot.16cebd3b.svg";